import { ColumnsType } from 'antd/lib/table'
import renderDate from '../../../../../../../helpers/tables/render-date'
import RewindQueueEntry from '../../../../../../../types/api/rewind-queue-entry'
import ShipmentPosition from '../../../../../../../types/api/shipment-position'
import { MaterialColumnCell } from '../../../../../flexo/components/cells/material-column-cell'
import { getShipmentFloods } from '../../../../helpers/get-shipment-floods'
import PrintEndTimeCell from '../../../cells/print-end-time-cell'
import RewindCopiesCell from '../../../cells/rewind-copies-cell'
import RewindJobNumberCell from '../../../cells/rewind-job-number-cell'
import ActionsCell from './actions-cell'

export const columns: ColumnsType<RewindQueueEntry> = [
    {
        dataIndex: ['rewind_job', 'id'],
        title: 'Номер перемотки',
        width: 70,
        render: (_value, record) => <RewindJobNumberCell rewindJob={record.rewind_job} />,
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'clientDeliveryDate'],
        title: 'Дата поставки',
        width: 70,
        render: (_value, record) => {
            const clientDeliveryDate = record.rewind_job?.shipment?.clientDeliveryDate

            return clientDeliveryDate ? renderDate(clientDeliveryDate) : '—'
        },
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'client', 'name'],
        title: 'Заказчик',
        render: (_value, record) => record.rewind_job?.shipment?.client?.name || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'shipment_positions'],
        title: 'Тираж',
        render: (_value: ShipmentPosition[], record) => (
            <RewindCopiesCell rewindJob={record.rewind_job} editable />
        ),
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'materialRequirements'],
        title: 'Материал',
        width: 100,
        render: (_value, record) => (
            <MaterialColumnCell value={record.rewind_job?.shipment?.materialRequirements || []} />
        ),
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'bushing'],
        title: 'Втулка',
        width: 70,
        render: (_value, record) => record.rewind_job?.shipment?.bushing || '—',
    },
    {
        key: 'floods',
        title: 'Ручьи',
        width: 70,
        render: (_value, record) => getShipmentFloods(record.rewind_job?.shipment) ?? '—',
    },
    {
        key: 'printEndAt',
        title: 'Время окончания печати',
        width: 90,
        render: (_value, record) => <PrintEndTimeCell shipment={record.rewind_job?.shipment} />,
    },
    {
        dataIndex: 'actions',
        title: '',
        fixed: 'right',
        render: (_value, record) => <ActionsCell rewindQueueEntry={record} />,
    },
]
